//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/Builder.js";
import "../no/SelectNXObject.js";
import "../no/SelectObject.js";
let d=[[[0,"AdvanceSpaceReservation",1,0],[0,"ComponentNamingMethod",1,0],[0,"NamingPattern",1,"Routing.NamingPatternBuilder",0],[1,"PartToAdvanceSelection",0,"SelectNXObject",0],[0,"ReportResultToInfowindow",1,0]],[[["num_generated_names"],"GetGeneratedNames",{R_:{generated_names:""}},0,0],[[],"GenerateAndValidateNames",{R_:{isValid:''}},0,0]],[]];
SPLM.Routing.AdvanceToRsdBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.AdvanceToRsdBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Routing.AdvanceToRsdBuilder.NamingMethod = Object.freeze({
    "Plugin" : "Plugin", "Incremental" : "Incremental"});

export default SPLM;